exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-19aee6df] {\n  font-size: 20px;\n  color: #0075be;\n  padding: 10px;\n}", ""]);

// exports
